import { getDeviceType } from '@cobliteam/api-lib';
import moment from 'moment';
import type { DeviceTrip, DeviceTripAPI } from './Definitions';

export const deviceTripsTransformer = (deviceTripAPI: DeviceTripAPI): DeviceTrip => ({
  deviceType: getDeviceType(deviceTripAPI.device.type),
  deviceId: deviceTripAPI.device.device_id,
  drivers: deviceTripAPI.drivers.map((driver) => ({
    id: driver.id,
    name: driver.name,
  })),
  vehicle: {
    licensePlate: deviceTripAPI.vehicle.license_plate,
    vehicleId: deviceTripAPI.vehicle.vehicle_id,
    fuelType: deviceTripAPI.vehicle.fuel_type,
    fuelPrice: deviceTripAPI.vehicle.fuel_price,
    fuelConsumption: deviceTripAPI.vehicle.fuel_consumption,
    brand: deviceTripAPI.vehicle.brand,
    model: deviceTripAPI.vehicle.model,
  },
  pathGeojson: {
    type: deviceTripAPI.path_geojson.type,
    geometry: deviceTripAPI.path_geojson.geometry,
    properties: deviceTripAPI.path_geojson.properties.timestamps.map((timestamp, index) => ({
      heading: deviceTripAPI.path_geojson.properties.headings[index],
      speedInKm: deviceTripAPI.path_geojson.properties.speeds_in_km[index],
      timestamp: moment(timestamp).valueOf(),
      accumulatedDistance: deviceTripAPI.path_geojson.properties.total_distances_in_m[index],
    })),
  },
});

export default deviceTripsTransformer;
